module.exports = __webpack_public_path__ + "static/img/A2E_India_4K5A7071.5a71eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_India_4K5A7071.jpg
// module id = PLea
// module chunks = 0